import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Row } from 'antd';
import React from 'react';
import { HeaderModalCustom } from 'src/screens/shared/Styles';

import { StyledModal } from './Styles';

type Props = {
  onCancel: () => void;
  description: string | React.ReactNode;
  title: string;
  mainButtonAction: () => void;
  mainButtonText: string;
  mainButtonStyle?: 'primary' | 'danger';
  secondaryButtonAction?: () => void;
  secondaryButtonText?: string;
  secondaryButtonStyle?: 'dashed' | 'default';
  leftButtonText?: string;
  leftButtonAction?: () => void;
  fetching?: boolean;
  open?: boolean;
};

const NotificationModal = ({
  open,
  onCancel,
  description,
  title,
  mainButtonAction,
  mainButtonText,
  mainButtonStyle = 'danger',
  secondaryButtonAction,
  secondaryButtonText,
  secondaryButtonStyle,
  leftButtonText,
  leftButtonAction,
  fetching,
}: Props) => {
  const [fetchingOnSecondary, setFetchingOnSecondary] = React.useState(false);

  const footer = [
    <Button
      key="main"
      type={mainButtonStyle === 'primary' ? 'primary' : 'default'}
      className={mainButtonStyle === 'danger' ? 'ant-btn-dangerous' : ''}
      onClick={() => {
        setFetchingOnSecondary(false);
        mainButtonAction();
      }}
      size="large"
      loading={!fetchingOnSecondary && fetching}
      data-testid="confirm-notification-modal-button"
      disabled={fetching}
    >
      {mainButtonText}
    </Button>,
  ];

  if (secondaryButtonAction && secondaryButtonText) {
    footer.unshift(
      <Button
        key="secondary"
        type={secondaryButtonStyle || 'dashed'}
        onClick={() => {
          setFetchingOnSecondary(true);
          secondaryButtonAction();
        }}
        size="large"
        loading={fetchingOnSecondary && fetching}
        disabled={fetching}
      >
        {secondaryButtonText}
      </Button>
    );
  }

  if (leftButtonText && leftButtonAction) {
    footer.unshift(
      <Button
        key="left"
        type={'dashed'}
        onClick={leftButtonAction}
        size="large"
        className="first-child"
      >
        {leftButtonText}
      </Button>
    );
  }

  return (
    <StyledModal
      closable
      open={open}
      onCancel={onCancel}
      {...(open === undefined && { transitionName: 'fade' })}
      {...(open === undefined && { open: true })}
      width={400}
      title={
        <HeaderModalCustom>
          <div>
            <h3>
              <InfoCircleOutlined />
              {title}
            </h3>
          </div>
        </HeaderModalCustom>
      }
      footer={footer}
    >
      <Row style={{ marginBottom: '10px' }}>
        <p>{description}</p>
      </Row>
    </StyledModal>
  );
};

export default NotificationModal;
